
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SupplierPaymentService, SupplierPaymentDto } from '../supplier-payment.service';
import { NotificationService } from '../../../core/notification.service';

@Component({
    selector: 'app-supplier-payment-detail',
    templateUrl: './supplier-payment-detail.component.html',
    standalone: false
})
export class SupplierPaymentDetailComponent implements OnInit {
    item: SupplierPaymentDto | null = null;
    loading = false;
    processingAction = false;

    constructor(
        private route: ActivatedRoute,
        private service: SupplierPaymentService,
        private notification: NotificationService
    ) { }

    ngOnInit(): void {
        const id = this.route.snapshot.paramMap.get('id');
        if (id) {
            this.load(id);
        }
    }

    load(id: string): void {
        this.loading = true;
        this.service.getTransacaoById(id).subscribe({
            next: (res) => {
                this.item = res;
                this.loading = false;
            },
            error: (err) => {
                console.error('Error loading detail', err);
                this.notification.showError('Erro ao carregar detalhes da transação');
                this.loading = false;
            }
        });
    }

    confirmar(): void {
        if (!this.item) return;
        const nsu = prompt('Informe o NSU/Código da transação manual:');
        if (!nsu) return;
        const reason = prompt('Motivo da confirmação manual:');
        if (!reason) return;

        this.processingAction = true;
        this.service.confirmarManual(this.item.id, nsu, reason).subscribe({
            next: () => {
                this.notification.showSuccess('Pagamento confirmado com sucesso!');
                this.load(this.item!.id);
                this.processingAction = false;
            },
            error: (err) => {
                console.error('Error confirming payment', err);
                this.notification.showError('Erro ao confirmar pagamento');
                this.processingAction = false;
            }
        });
    }

    cancelar(): void {
        if (!this.item) return;
        const reason = prompt('Motivo do cancelamento:');
        if (!reason) return;

        this.processingAction = true;
        this.service.cancelar(this.item.id, reason).subscribe({
            next: () => {
                this.notification.showSuccess('Transação cancelada.');
                this.load(this.item!.id);
                this.processingAction = false;
            },
            error: (err) => {
                console.error('Error cancelling payment', err);
                this.notification.showError('Erro ao cancelar transação');
                this.processingAction = false;
            }
        });
    }

    expirar(): void {
        if (!this.item || !confirm('Tem certeza que deseja expirar esta transação?')) return;

        this.processingAction = true;
        this.service.expirar(this.item.id).subscribe({
            next: () => {
                this.notification.showSuccess('Transação expirada.');
                this.load(this.item!.id);
                this.processingAction = false;
            },
            error: (err) => {
                console.error('Error expiring payment', err);
                this.notification.showError('Erro ao expirar transação');
                this.processingAction = false;
            }
        });
    }

    getStatusClass(status: string): string {
        switch (status) {
            case 'PAID': return 'bg-green-100 text-green-800';
            case 'AWAITING_PAYMENT': return 'bg-yellow-100 text-yellow-800';
            case 'EXPIRED': return 'bg-gray-100 text-gray-800';
            case 'CANCELLED': return 'bg-red-100 text-red-800';
            default: return 'bg-gray-100 text-gray-800';
        }
    }

    getStatusLabel(status: string): string {
        switch (status) {
            case 'PAID': return 'Pago';
            case 'AWAITING_PAYMENT': return 'Aguardando';
            case 'EXPIRED': return 'Expirado';
            case 'CANCELLED': return 'Cancelado';
            default: return status;
        }
    }
}
